import { get, some } from 'lodash/fp';
import { parseInt } from '../utils';

export default (reservation, fieldsSttings) => {
  if (!reservation || !fieldsSttings) return false;

  const mainFields = [
    'firstName',
    'lastName',
    'email',
    'homePhone',
    'workPhone',
    'cellPhone',
    'householdTotal'
  ];

  const isHomeless = parseInt(get('homeless', reservation)) === 1;

  const addressFields = !isHomeless
    ? ['streetAddress', 'city', 'state', 'zipCode', 'county']
    : [];

  const allFields = [...mainFields, ...addressFields];

  const hasEmptyRequiredField = some(field => {
    if (
      get(`${field}.show`, fieldsSttings) &&
      get(`${field}.isRequired`, fieldsSttings) &&
      !get(field, reservation)
    ) {
      return true;
    }
    return false;
  }, allFields);

  return !hasEmptyRequiredField;
};
